import { Loader, NotificationPopup } from "../../libs"
import Form from "./Form"
import { useEffect, useState } from "react"
import { Error } from "../natal-telegram/helpers/errors"
import styled from "styled-components"
import '../../i18n/i18n';
import { loadLocale } from "../../helpers/utils"
import i18n from "../../i18n/i18n"
import dayjs from "dayjs"
import AppEmptyPage from "../../components/AppEmptyPage"

export default function NatalFreeNewApp({
  token,
  partner
}: {
  token: string
  partner: string
}){
  const [error, setError] = useState<Error | null>(null)
  const [translationsInit, setTranslationsInit] = useState(false);

  const initLng = async (lng: string) => {
    // await loadLocale(lng);
    // dayjs.locale(lng);
    setTranslationsInit(true);
  };
  
  useEffect(() => {
    i18n.on('loaded', async () => {
        await initLng(i18n.language);
    });
  },[])

  if (!translationsInit) {
    return <AppEmptyPage><Loader /></AppEmptyPage>;
  }
  
  return (
    <Container>
      <Form token={token} partner={partner} setError={(value) => setError(value)} />
      {/* @ts-ignore */}
      {error && (
        <StyledNotificationPopup
          type={'warning'}
          size={'small'}
          title={error.title}
          // @ts-ignore
          content={error.content}
          onClose={() => setError(null)}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
`;

const StyledNotificationPopup = styled(NotificationPopup)`
  & > div {
    border-radius: 0.4rem;
  }

  .title {
    text-align: left;
    margin-top: 2rem;
  }

  .content {
    text-align: left;
    margin-top: 1.5rem;
  }

  @media (max-width: 460px) {
    & > div {
      height: 40%;
    }
  }
`;
